import { FcsFlag } from "../unleash";

export const FlagsDropoffAutoSelect = {
  dropoff_auto_select_kecamatan: new FcsFlag.Flag(false)
};

export function initFlagsDropoffAutoSelect() {
  FcsFlag.register("website", FlagsDropoffAutoSelect);
}
